import { MarketingCampaignModel, IMarketingCampaign } from "@core/models";

export const mockCampaignLink = new MarketingCampaignModel({
  [IMarketingCampaign.campaignId]: "107264",
  [IMarketingCampaign.message]: "<p>ici le text de la popup en g&eacute;n&eacute;rale !</p>",
  [IMarketingCampaign.type]: "link",
  [IMarketingCampaign.param]: "http://www.google.com/",
  [IMarketingCampaign.title]: "Un lien externe",
  [IMarketingCampaign.code]: "campagne-test",
});

export const mockCampaignAction = new MarketingCampaignModel({
  [IMarketingCampaign.campaignId]: "107265",
  [IMarketingCampaign.message]: "<p>ici le text de la popup en g&eacute;n&eacute;rale !</p>",
  [IMarketingCampaign.type]: "action",
  [IMarketingCampaign.route]: "/mon-espace/profil",
  [IMarketingCampaign.title]: "Une action",
  [IMarketingCampaign.code]: "campagne-test",
});

export const mockCampaignOk = new MarketingCampaignModel({
  [IMarketingCampaign.campaignId]: "107266",
  [IMarketingCampaign.message]: "<p>ici le text de la popup en g&eacute;n&eacute;rale !</p>",
  [IMarketingCampaign.type]: "ok",
  [IMarketingCampaign.title]: "Simple notification",
  [IMarketingCampaign.code]: "campagne-test",
});
